import React from 'react';

import Page from '@components/layout/Page';
import ProductsPage from '@components/products';
import MetaPage from '@components/common/MetaPage';
import JsonLd from '@components/common/JsonLd';
import { LocationDependent } from '@content/types/general';
import DataLayer from '@components/layout/DataLayer';
import useProductPageQuery from '@graphql/queries/ProductQuery';
import useConfiguratorQuery from '@graphql/queries/ConfiguratorQuery';
import { PageContext } from '@content/types/pageContext';
import * as utils from '@utils';
import { absoluteUrl, buildItemListSchema } from '@utils/structuredData';

interface Props extends LocationDependent {
  pageContext: PageContext;
}

const ProductPage = (props: Props) => {
  const { langcode } = props.pageContext;
  const productPageQuery = useProductPageQuery()[langcode];
  const shopUrl = absoluteUrl(utils.langLink(langcode, '/sklep'));
  const productItems = (useConfiguratorQuery().products[langcode] || []).map(product => ({
    name: product.name,
    description: product.description,
  }));

  return (
    <Page>
      <MetaPage
        title={productPageQuery.seo.title}
        description={productPageQuery.seo.description}
        image={productPageQuery.seo.image}
      />
      <JsonLd schema={buildItemListSchema(productItems, shopUrl)} />
      <DataLayer location={props.location} />
      <ProductsPage
        {...productPageQuery}
        langcode={props.pageContext.langcode}
        urls={props.pageContext.allUrls}
      />
    </Page>
  );
};

export default ProductPage;
